import { render, staticRenderFns } from "./revolva.toolBar.vue?vue&type=template&id=7c2f1c65&scoped=true&"
import script from "./revolva.toolBar.vue?vue&type=script&lang=ts&"
export * from "./revolva.toolBar.vue?vue&type=script&lang=ts&"
import style0 from "./revolva.toolBar.vue?vue&type=style&index=0&id=7c2f1c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f1c65",
  null
  
)

export default component.exports